<template>
  <div class="data-migration">
    <div class="data-migration__header">
      <h3>方正云阅读·历史数据迁移服务</h3>
      <div class="data-migration__title">
        <h3 class="data-migration__title__left">/{{ userName }}/{{ dataMigrationItem.name }}/</h3>
        <div class="data-migration__title__right">
          <span>已上传数量:{{ migInfo.uploadNum || 0 }}/{{ migInfo.authNum || 0 }}</span>
          <span>已用空间:{{ migInfo.usedSpace || 0 }}/{{ migInfo.authSpace || 0 }} G</span>

          <div id="container">
            <el-button id="selectfiles" href="javascript:void(0);" class="btn" :disabled="disabledUpload">选择文件</el-button>
            <el-button @click="uploadFile" id="postfiles" href="javascript:void(0);" class="btn" :disabled="disabled">上传</el-button>
            <el-button class="btn" @click="clearFiles">清空</el-button>
          </div>
          <div id="ossfile">你的浏览器不支持flash,Silverlight或者HTML5！</div>
          <p id="console"></p>
          <span class="tip" v-if="isOver">当前已选择文件已超出授权数，清空文件后重新进行上传</span>
        </div>
      </div>
    </div>

    <ul class="data-migration__content">
      <li v-for="item in tableData" :key="item.id">
        <span class="data-migration__content__name">{{ item.fileName }}</span>
        <span>{{ item.createTime | time }}</span>
        <span>{{ item.usedSpace }}KB</span>
      </li>
    </ul>

    <span @click="goback" style="cursor: pointer">返回</span>
  </div>
</template>
<script>
import api from '@api/paperManager'
import moment from 'moment/moment'

export default {
  name: 'DataMigration',
  props: {
    dataMigrationItem: {
      default: {}
    }
  },
  data() {
    return {
      tableData: [],
      migInfo: {},
      latestFilename: '',
      disabled: false,
      disabledUpload: false,
      fileNum: 0,
      uploader: null,
      isOver: false,
      fileList: [],
      isUploaded: false,
      fileSize: 0,
      clearDisabled: true
    }
  },
  filters: {
    time(val) {
      return moment(val).format('YYYY/MM/DD hh:mm')
    }
  },
  computed: {
    userName() {
      return localStorage.getItem('username')
    }
  },

  methods: {
    selectFile() {
      // const uploadNum = this.migInfo.uploadNum || 0
      // this.disabledUpload = sessionStorage.getItem('fileNum') * 1 + uploadNum * 1 >= this.migInfo.authNum
    },
    refreshDisableUpload() {
      const uploadNum = this.migInfo.uploadNum || 0
      if (this.isUploaded) {
        this.disabledUpload = this.fileNum + uploadNum * 1 > this.migInfo.authNum
      } else {
        this.disabledUpload = this.fileNum + uploadNum * 1 >= this.migInfo.authNum
      }
    },
    filesAddedCallback(up, files) {
      console.log(files)
      this.fileNum += files.length
      files.forEach((_) => {
        this.fileSize += _.size
      })
      this.refreshDisableUpload()
      this.handleDisabled(this.fileSize)
      const uploadNum = this.migInfo.uploadNum || 0
      if (this.isUploaded) {
        if (this.fileNum + uploadNum * 1 > this.migInfo.authNum) {
          this.disabled = true
          this.isOver = true
          this.clearDisabled = false
        }
      } else {
        if (this.fileNum + uploadNum * 1 >= this.migInfo.authNum) {
          // this.disabled = true
          // this.isOver = true
        }
        if (this.fileNum + uploadNum * 1 > this.migInfo.authNum) {
          this.disabled = true
          this.isOver = true
          this.clearDisabled = false
        }
      }
      this.uploader = up
      this.fileList = files
      // console.log(this.uploader)
    },
    uploadFile() {},
    handleDisabled(size = 0) {
      let fileSize = (size / (1024 * 1024 * 1024)).toFixed(2) * 1
      let usedSpace = this.migInfo.usedSpace * 1
      if (this.migInfo.uploadNum >= this.migInfo.authNum) {
        this.disabled = true
      } else {
        this.disabled = (usedSpace + fileSize).toFixed(2) >= this.migInfo.authSpace * 1
      }
    },
    goback() {
      this.$emit('goBack')
    },
    uploadCallback(up, file, info) {
      if (info.status == 200) {
        this.batchAddMigrateFile(file)
        this.getMigrateAuth()
        this.isUploaded = true
      }
    },
    batchAddMigrateFile(file) {
      this.latestFilename = file.name
      const params = [
        {
          userName: this.userName,
          newspaper: this.dataMigrationItem.name,
          fileName: file.name,
          usedSpace: file.size,
          migrateAuthId: this.migInfo.id
        }
      ]
      api.batchAddMigrateFile(encodeURI(JSON.stringify(params))).then((res) => {
        if (res.data.status == 0) {
          if (file.name === this.latestFilename) {
            this.getMigrateAuth()
          }
        }
      })
    },
    getMigrateFileAccountByQuery() {
      const params = {
        pageNo: 1,
        pageSize: 999,
        userName: this.userName,
        newspaper: this.dataMigrationItem.name,
        migrateAuthId: this.migInfo.id
      }
      api.getMigrateFileAccountByQuery(params).then((res) => {
        let { data, status } = res.data
        if (status === 0) {
          this.tableData = data.content
          const uploadNum = this.migInfo.uploadNum || 0
          this.disabledUpload = uploadNum * 1 >= this.migInfo.authNum
        }
      })
    },
    getMigrateAuth() {
      const params = {
        userName: this.userName,
        newspaper: this.dataMigrationItem.name
      }
      api.getMigrateAuth(params).then((res) => {
        if (res.data.status == 0) {
          this.migInfo = res.data.data
          this.disabledUpload = this.migInfo.uploadNum >= this.migInfo.authNum

          this.getMigrateFileAccountByQuery()
          if (this.migInfo.usedSpace) this.migInfo.usedSpace = (this.migInfo.usedSpace / (1024 * 1024 * 1024)).toFixed(2)
          // this.migInfo.authSpace = 0.3
          this.handleDisabled()
        }
      })
    },
    clearFiles() {
      if (this.uploader) {
        while (this.uploader.files.length > 0) {
          this.uploader.removeFile(this.uploader.files[0])
        }
        // this.uploader.splice(1)
        this.fileNum = 0
        this.fileSize = 0
        // this.fileList = []
        document.getElementById('ossfile').innerHTML = ''
        document.getElementById('console').innerHTML = ''
        this.refreshDisableUpload()
        this.isOver = false
        this.disabled = false
      }
    }
  },
  created() {
    this.getMigrateAuth()
    // this.getMigrateFileAccountByQuery()
  },
  mounted() {
    window.uploaderInit({
      uploadedCallback: this.uploadCallback,
      filesAddedCallback: this.filesAddedCallback
    })
  }
}
</script>

<style scoped lang="scss">
.data-migration {
  padding: 20px 10px;
  margin-bottom: 80px;
  &__header {
    padding: 0 10px;
    border-bottom: 1px solid gray;
  }
  &__title {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 20px;
    #container {
      display: inline-block;
      a {
        display: inline-block;
        padding: 7px 20px;
        margin-right: 5px;
        background-color: #295999;
        color: #fff;
        text-decoration: none;
        border-radius: 6px;
        font-size: 16px;
      }
    }
    #ossfile {
      max-height: 60px;
      overflow-y: scroll;
      margin-bottom: 10px;
    }
    #console {
      margin-bottom: 5px;
    }
    &__right {
      span {
        margin-right: 30px;
        font-size: 20px;
        font-weight: bold;
      }
      .tip {
        font-weight: normal;
        font-size: 14px;
      }
    }
  }
  &__content {
    padding: 20px 10px;
    border-bottom: 1px solid gray;
    max-height: 270px;
    overflow-y: scroll;
    li {
      line-height: 30px;
    }
    li span {
      margin-right: 50px;
    }
    &__name {
      display: inline-block;
      width: 240px;
    }
  }
}
</style>
